import { render } from "./RegisterFishView.vue?vue&type=template&id=74bc2fab"
import script from "./RegisterFishView.vue?vue&type=script&lang=js"
export * from "./RegisterFishView.vue?vue&type=script&lang=js"

import exportComponent from "/home/christian/Trabalho/fish_coletor/Coletor-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__